module.exports = __webpack_public_path__ + "static/img/MindfulSolver.dbd280b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ui/reports/MindfulSolver.png
// module id = 94vM
// module chunks = 1